var L={SMALL:"SMALL",MEDIUM:"MEDIUM",LARGE:"LARGE"};export{L as default};
//# sourceMappingURL=illustrationConst.js.map
